import { accordionPanelStyles } from '../../../shared/boxes/accordionPanel/accordionPanelRender';

/**
 * Aperçu d'un style de Volet : le volet du document, déplié, avec un texte
 * d'exemple à la place des éditeurs.
 */
const AccordionPanelPreview = ({
  style,
  width,
  question = 'Quels sont vos délais ?',
  answer = 'Nous livrons généralement sous 2 à 4 semaines.',
}) => {
  const preview = accordionPanelStyles(style);
  return (
    <div style={{ width, ...preview.frame }}>
      <div style={{
        padding: '12px 16px',
        fontWeight: 600,
        ...preview.header,
        ...(style?.questionColor ? { color: style.questionColor } : {}),
      }}>
        {question}
      </div>
      <div style={{
        padding: '12px 16px',
        ...preview.answer,
        ...(style?.answerColor ? { color: style.answerColor } : {}),
      }}>
        {answer}
      </div>
    </div>
  );
};

export default AccordionPanelPreview;
